'use strict';

/* globals RELATIVE_PATH, $, utils */

require([RELATIVE_PATH + '/plugins/nodebb-plugin-lessons/static/vendor/vue.js'], function (Vue) {
	var internals = {};

	Vue.component('lesson-question', {
		props: ['initData', 'question', 'answerTypes', 'answered'],
		watch: {
			question: function () {
				this.renderVideo();
			},
		},
		mounted: function () {
			this.$nextTick(function () {
				this.renderVideo();
			});
		},
		methods: {
			renderVideo: function () {
				var me = this;

				if (this.question.media.video) {
					setTimeout(function () { internals.addVideo(me.question.media.video); }, 250);
				}
			}
		},
		template: 
		'<div class="lesson-question-view">' +
			'<div class="lesson-question">{{question.question}}</div>' +
			'<div class="lesson-question" v-if="question.media.video"><div class="question-video"></div></div>' +
			'<div class="lesson-question" v-if="question.media.image"><img :src="question.media.image" alt="" style="max-height: 100%; max-width: 100%;" /></div>' +
			'<div class="lesson-question" v-if="question.media.sound"><audio controls><source :src="question.media.sound" type="audio/mpeg"></audio></div>' +
			'<div class="lesson-answers">' +
				'<div class="row equal">' +
					'<answer-view class="col-md-6 col-xs-12" v-for="answer in question.answers" :init-data="initData" :answer="answer" :answer-types="answerTypes" :answered="answered"></answer-view>' +
				'</div>' +
			'</div>' +
		'</div>',
	});

	// workaround
	internals.addVideo = function (video) {
		var id = utils.generateUUID();

		var videoElement = $('<div class="' + id + '" data-video-url="' + video + '"></div>');

		$('.question-video').html(videoElement);

		$('.' + id).customVideo();
	};
});
